import ParthnerIconsList from './List'
import ParthnerIconEdit from './Edit'
import ParthnerIconCreate from './Create'

const ParthnerIconResource = {
  list: ParthnerIconsList,
  edit: ParthnerIconEdit,
  create: ParthnerIconCreate,
}

export default ParthnerIconResource
